export const KODAWARI = {
  // 雇用形態
  employmentStatus: [
    {
      value: '1',
      text: '正社員',
    },
    {
      value: '2',
      text: '契約社員',
    },
    {
      value: '3',
      text: 'その他',
    },
  ],
  // 募集・採用情報
  requirements: [
    {
      value: '1',
      text: '職種未経験歓迎',
    },
    {
      value: '2',
      text: '業種未経験歓迎',
    },
    {
      value: '3',
      text: '学歴不問',
    },
    {
      value: '4',
      text: '転勤なし',
    },
    {
      value: '5',
      text: '第二新卒歓迎',
    },
    {
      value: '6',
      text: '社会人経験10年以上歓迎',
    },
    {
      value: '7',
      text: '急募！入社まで1カ月',
    },
    {
      value: '8',
      text: '5名以上採用',
    },
    {
      value: '9',
      text: '入社後の職種変更なし',
    },
  ],
  // 会社・職場の環境
  workplaceEnvironment: [
    {
      value: '1',
      text: '上場企業',
    },
    {
      value: '2',
      text: '外資系企業',
    },
    {
      value: '3',
      text: '定着率95％以上',
    },
    {
      value: '4',
      text: '女性活躍',
    },
    {
      value: '5',
      text: '自動車通勤OK',
    },
    {
      value: '6',
      text: '服装自由',
    },
  ],
};

export const KODAWARI_MAP = {
  employmentStatus: new Map(
    KODAWARI.employmentStatus.map(({ value, text }) => [value, text])
  ),
  requirements: new Map(
    KODAWARI.requirements.map(({ value, text }) => [value, text])
  ),
  workplaceEnvironment: new Map(
    KODAWARI.workplaceEnvironment.map(({ value, text }) => [value, text])
  ),
};

export type KodawariType = keyof typeof KODAWARI;

// 求人カードに表示するこだわり情報
export const JOB_CARD_KODAWARI = {
  employmentStatus: [
    { value: '1', order: 1 },
    { value: '2', order: 2 },
    { value: '3', order: 3 },
  ],
  requirements: [
    { value: '1', order: 7 },
    { value: '2', order: 8 },
    { value: '4', order: 4 },
    { value: '8', order: 6 },
  ],
  workplaceEnvironment: [{ value: '1', order: 5 }],
};
